import Repository from '../Repository';

export default {

	createAssessment(structure) {
		let response = Repository.post('AssessmentStructure/CreateAssessment', 
			structure
		);
		return response;
	},

	deleteAssessment(assessmentId) {
		let response = Repository.delete('AssessmentStructure/DeleteAssessment', {
			params: {		
				assessmentId: assessmentId
			}
		});
		return response;		
	},

	deleteAssessmentStructure(assessmentId) {
		let response = Repository.delete('AssessmentStructure/DeleteAssessmentStructure', {
			params: {		
				assessmentId: assessmentId
			}
		});
		return response;		
	},

	duplicateAssessment(sourceAssessmentId, periodId, qualificationId, languageId, 
						subjectId, assessmentCodeId, assessmentTypeId, subPeriodId, 
						overwrite) {
		let response = Repository.post('AssessmentStructure/DuplicateAssessment', 
			{
				sourceAssessmentId: sourceAssessmentId, 
				periodId: periodId,
				qualificationId: qualificationId, 
				languageId: languageId,
				subjectId: subjectId,
				assessmentCodeId: assessmentCodeId, 
				assessmentTypeId: assessmentTypeId,
				subPeriodId: subPeriodId,
				overwriteExistingAssessmentStructure: overwrite
			}
		);
		return response;
	},

	getAssessmentStructure(assessmentId) {
		let response = Repository.get('AssessmentStructure/GetAssessmentStructure', {
			params: {
				assessmentId: assessmentId	
			}
		});
		return response;
	},

	getAssessmentStructureAuditLogs(pageSize, pageNumber, searchString) {
		let response = Repository.get('AssessmentStructure/GetAssessmentStructureAuditLogs', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,
				SearchString: searchString,
				orderDirection: 'desc',
				SortBy: 'createTime'
			}
		});
		return response;
	},

	listAssessments(pageSize, pageNumber, searchString, assessmentStatusId, periodIds, subPeriodIds, subjectId, qualificationId, assessmentCodeId, languageId, assessmentTypeId, markingTypeId) {
		let response = Repository.get('AssessmentStructure/ListAssessments', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,
				searchString: searchString,		
				assessmentStatusIdCSV: assessmentStatusId || '',
				periodIdCSV: Array.isArray(periodIds)
								? periodIds.join(',')
								: String(periodIds ?? ''),
				subPeriodIdCSV: Array.isArray(subPeriodIds)
								? subPeriodIds.join(',')
								: String(subPeriodIds ?? ''),
				subjectIdCSV: subjectId || '',
				qualificationIdCSV: qualificationId || '',
				assessmentCodeIdCSV: assessmentCodeId || '',
				languageIdCSV: languageId || '',
				assessmentTypeIdCSV: assessmentTypeId || '',
				markingTypeIdCSV: markingTypeId || '',
				isActive: true
			}
		});
		return response;
	},

	listAssessmentsCsv(assessmentStatusId, periodIds, subPeriodIds, subjectId, qualificationId, assessmentCodeId, languageId, assessmentTypeId, markingTypeId) {
		let response = Repository.get('AssessmentStructure/ListAssessmentsCsv', {
			params: {	
				assessmentStatusIdCSV: assessmentStatusId || '',
				periodIdCSV: periodIds.join(',') || '',
				subPeriodIdCSV: subPeriodIds.join(',') || '',
				subjectIdCSV: subjectId || '',
				qualificationIdCSV: qualificationId || '',
				assessmentCodeIdCSV: assessmentCodeId || '',
				languageIdCSV: languageId || '',
				assessmentTypeIdCSV: assessmentTypeId || '',
				markingTypeIdCSV: markingTypeId || '',
				Csv: true,
				isActive: true
			}
		});
		return response;
	},

	updateAssessment(assessmentId, qualificationId, languageId, subjectId, periodId, subPeriodId, assessmentTypeId, inDevelopment, total, assessmentCodeId, questionsOnly, overwriteExistingAssessmentStructure) {

		let response;

		// build structure for update

		let updateStructure = {
			assessmentId: assessmentId,
			qualificationId: qualificationId,
			languageId: languageId,
			subjectId: subjectId,
			periodId: periodId,
			subPeriodId: subPeriodId, 
			assessmentTypeId: assessmentTypeId, 
			inDevelopment: inDevelopment,
			total: total,
			assessmentCodeId: assessmentCodeId,
			questionsOnly: questionsOnly,
			overwriteExistingAssessmentStructure: overwriteExistingAssessmentStructure
		};

		response = Repository.put('AssessmentStructure/UpdateAssessment', updateStructure);

		return response;		
	},

	updateAssessmentMarkingType(newMarkTypeId, assessmentId, assessmentStatusId, markingTypeId, qualificationId, languageId, subjectId, periodId, subPeriodId, assessmentTypeId, assessmentCodeId, confirmation) {

		let response;

		response = Repository.put('AssessmentStructure/UpdateAssessmentMarkingType', {
			newMarkTypeId: newMarkTypeId,
			assessmentId: assessmentId,
			assessmentStatusId: (assessmentStatusId > 0) ? assessmentStatusId : null,
			markingTypeId: (markingTypeId > 0) ? markingTypeId : null,
			qualificationId: (qualificationId > 0) ? qualificationId : null,
			languageId: (languageId > 0) ? languageId : null,
			subjectId: (subjectId > 0) ? subjectId : null,
			periodId: (periodId > 0) ? periodId : null,
			subPeriodId: (subPeriodId > 0) ? subPeriodId : null,
			assessmentTypeId: (assessmentTypeId > 0) ? assessmentTypeId : null,
			assessmentCodeId: (assessmentCodeId > 0) ? assessmentCodeId : null,
			confirmation: confirmation
		});

		return response;		
	},

	updateAssessmentPaperTotal(assessmentId, total) {

		let response;

		// build structure for update

		let updateStructure = {
			assessmentId: assessmentId,
			total: total		
		};

		response = Repository.put('AssessmentStructure/UpdateAssessment', updateStructure);

		return response;		
	},

	updateAssessmentStructure(assessmentStructure) {
		let response;

		response = Repository.put('AssessmentStructure/UpdateAssessmentStructure', {
			assessmentId: assessmentStructure.assessmentId,
			sectionGroups: assessmentStructure.sectionGroups
		});
		return response;		
	}

}
